import styled from 'styled-components';
import { StyledTheme, StyledThemeCheckoutMixin } from '../../../../styles';
import { SelectInputBaseStyles } from './select-input-base.styles';
import { SelectInputInvalidStyles } from './select-input-invalid.styles';
import { SelectInputDateStyles } from './select-input-date.styles';

export const SelectInputStyles = styled.div<{ theme: StyledTheme }>`
  ${StyledThemeCheckoutMixin}

  &.selectInputBase {
    ${SelectInputBaseStyles}
  }

  &.selectInputInvalid {
    ${SelectInputInvalidStyles}
  }

  &.selectInputDate {
    ${SelectInputDateStyles}
  }
`;
